import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=3f80818c&scoped=true&"
import script from "./footer.vue?vue&type=script&lang=ts&"
export * from "./footer.vue?vue&type=script&lang=ts&"
import style0 from "./footer.vue?vue&type=style&index=0&id=3f80818c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f80818c",
  null
  
)

export default component.exports